import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import { List, DangerTriangle, InfoCircle } from "@mynaui/icons-react";

const severityConfig = {
  critical: { icon: DangerTriangle, color: "#DC2626" },
  warning: { icon: DangerTriangle, color: "#D97706" },
  info: { icon: InfoCircle, color: "#2B7FFF" },
};

const RiskAlertHistory = ({ alerts }) => {
  return (
    <Card sx={{ borderRadius: 1, flex: 1, boxShadow: "none", border: "none" }}>
      <CardContent sx={{ p: 2.5, "&:last-child": { pb: 2.5 } }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
          <List size={24} color="#020618" strokeWidth={1.5} />
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "18px",
              lineHeight: "28px",
              color: "#111827",
            }}
          >
            Risk Alert History
          </Typography>
        </Box>

        <Box sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
          {alerts.map((alert, index) => {
            const config =
              severityConfig[alert.severity] || severityConfig.info;
            const Icon = config.icon;
            return (
              <Box
                key={alert.id}
                sx={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 1.5,
                  py: 1.5,
                  marginTop: "14px",
                  borderBottom:
                    index < alerts.length - 1 ? "1px solid #E2E8F0" : "none",
                }}
              >
                <Icon size={24} color={config.color} strokeWidth={1.5} />
                <Box>
                  <Typography
                    sx={{
                      fontWeight: 400,
                      fontSize: "14px",
                      lineHeight: "20px",
                      color: "#020618",
                      mb: 1,
                    }}
                  >
                    {alert.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontWeight: 400,
                      fontSize: "12px",
                      lineHeight: "16px",
                      color: "#62748E",
                    }}
                  >
                    {alert.timeAgo}
                  </Typography>
                </Box>
              </Box>
            );
          })}
        </Box>
      </CardContent>
    </Card>
  );
};

export default RiskAlertHistory;
